module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/322.e4183b56.png";